/**
 * Build-time configuration.
 *
 * Everything the dashboard needs to reach the API comes from `VITE_*`
 * variables, so the same bundle can be pointed at a local, staging or
 * production backend without a code change. Nothing secret lives here — Vite
 * inlines these values into the JavaScript every visitor downloads.
 */

function readString(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : fallback
}

function readNumber(value: unknown, fallback: number): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

/** Trailing slashes would produce `//api/...` once a path is appended. */
function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

export const env = {
  apiBaseUrl: stripTrailingSlash(readString(import.meta.env.VITE_API_BASE_URL, 'http://localhost:8081')),
  appName: readString(import.meta.env.VITE_APP_NAME, 'Drive For Me'),
  apiTimeoutMs: readNumber(import.meta.env.VITE_API_TIMEOUT_MS, 30_000),

  /** OpenStreetMap raster tiles for the route map. */
  mapTileUrl: readString(import.meta.env.VITE_MAP_TILE_URL, 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'),

  /**
   * Road routing for the line drawn between pickup and drop-off.
   *
   * Defaults to the public OSRM demo server, which needs no key but carries no
   * guarantee — point this at a self-hosted OSRM if the map starts falling back
   * to straight lines. The dashboard degrades to one rather than failing, so a
   * routing outage costs the road geometry and nothing else.
   */
  osrmBaseUrl: stripTrailingSlash(
    readString(import.meta.env.VITE_OSRM_BASE_URL, 'https://router.project-osrm.org'),
  ),
} as const

export type Env = typeof env
